var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiative6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32 28.2491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.932842 12.4318H31.0671C32.3114 12.3823 32.3105 10.6053 31.0671 10.5562H0.932842C-0.311416 10.6058 -0.310478 12.3827 0.932842 12.4318ZM23.7149 2.71319C21.6297 0.964272 18.9897 0.00109988 16.2813 0.00109988H15.7187C10.5781 -0.0739858 5.72713 3.70399 4.49675 8.68072H27.5032C26.8967 6.36675 25.5709 4.26985 23.7149 2.71319ZM31.0671 26.3736H30.3168V14.3074H25.1903V26.3735H23.3147V14.3074H20.0637V26.3735H18.1881V21.1219H13.8118V26.3735H11.9362V14.3074H8.68523V26.3735H6.80965V14.3074H1.68307V26.3735H0.933155C-0.311104 26.4231 -0.310166 28.2001 0.933155 28.2491H31.0671C32.3114 28.1996 32.3105 26.4227 31.0671 26.3736Z",
    fill: "var(--fill-0, #B707AB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8112 14.3073H18.1875V19.2463H13.8112V14.3073Z",
    fill: "var(--fill-0, #B707AB)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiative6);
export default __webpack_public_path__ + "static/media/initiative-6.851a1966a09c8f64c3987496ddb681c1.svg";
export { ForwardRef as ReactComponent };